import { AuthenticatedHttpClient } from "@/lib/axios";
import { AxiosResponse } from "axios";

export interface User {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  password: string;
}

export class UserService {
  private http: AuthenticatedHttpClient;

  constructor(httpClient: AuthenticatedHttpClient) {
    this.http = httpClient;
  }

  async updateUser(user: Partial<User>): Promise<AxiosResponse<User>> {
    return this.http.patch<User>("/user", user);
  }

  async getUser(): Promise<AxiosResponse<User>> {
    const response = await this.http.get<User>("/user/me");
    return { data: response } as unknown as AxiosResponse<User>;
  }

  async onboardUser(): Promise<AxiosResponse<User>> {
    const response = await this.http.post<User>("/onboarding", {});
    return { data: response } as unknown as AxiosResponse<User>;
  }
}
